import {
  Badge,
  Box,
  FormControl,
  FormLabel,
  Input,
  Select, SimpleGrid, Text, useColorModeValue
} from "@chakra-ui/react";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { ContatoType } from "models/contato_type";
import { Project } from "models/project_type";
import { OptionType } from "models/select_mode";
import { UsuarioModel } from "models/user_model";
interface IProjectHeader {
  accountSelected: Project;
  contatoAgencia: ContatoType;
  contatoCliente: ContatoType;
  users: UsuarioModel[];
}

const ProjectHeader = ({
  accountSelected,
  contatoAgencia,
  contatoCliente,
  users,
}: IProjectHeader) => {
  const textColor = useColorModeValue("navy.700", "white");

  return (
    <Box>
      <SimpleGrid columns={4} spacing={2} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={"black"}
            mb="8px"
          >
            Código de Projeto
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder=" Código de Projeto"
            fontWeight="500"
            size="md"
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={"black"}
            mb="8px"
          >
            Nome do Projeto
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Nome do Projeto"
            fontWeight="500"
            size="md"
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={"black"}
            mb="8px"
          >
            Executivo Broders Responsável
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Executivo Broders Responsável"
            fontWeight="500"
            disabled={true}
            value={users[1]?.nome}
            size="md"
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={"black"}
            mb="8px"
          >
            Produtor Broders Responsável
          </FormLabel>

          <Input
            isRequired={true}
            fontSize="sm"
            disabled={true}
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Produtor Broders Responsável"
            fontWeight="500"
            value={users[0]?.nome}
            size="md"
          />
        </FormControl>
      </SimpleGrid>

      {accountSelected?.Orcamento?.showAgencia && (
        <SimpleGrid columns={4} spacing={2} mt={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Agência
            </FormLabel>

            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size="md"
              onChange={(e) => {}}
              placeholder="Busque a Agência"
              name={"agencia"}
              value={{
                label: accountSelected?.Orcamento?.agencia?.nome,
                value: accountSelected?.Orcamento?.agencia?.id,
              }}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Nome do Contato da Agência
            </FormLabel>
            <Select value={contatoAgencia?.id} size="md" onChange={(e) => {}}>
              <option value={contatoAgencia?.id}>{contatoAgencia?.nome}</option>
            </Select>
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Email do Contato da Agência
            </FormLabel>

            <Input
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Email do Contato da Agência"
              fontWeight="bold"
              size="md"
              disabled={true}
              value={accountSelected?.Orcamento?.contatoAgenciaEmail}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="bold"
              color={textColor}
              mb="8px"
            >
              Telefone do Contato da Agência
            </FormLabel>

            <Input
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder=" Telefone do Contato da Agência"
              fontWeight="bold"
              size="md"
              disabled={false}
              value={accountSelected?.Orcamento?.contatoAgenciaTelefone}
            />
          </FormControl>
        </SimpleGrid>
      )}

      <SimpleGrid columns={4} spacing={2} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Cliente
          </FormLabel>

          <AutoComplete<OptionType, false, GroupBase<OptionType>>
            size="md"
            placeholder="Busque o Cliente"
            isRequired={true}
            name={"cliente"}
            defaultValue={{
              label: accountSelected?.Orcamento?.cliente?.nome,
              value: accountSelected?.Orcamento?.cliente?.id,
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Nome do Contato do Responsável do Cliente
          </FormLabel>
          <Select value={contatoCliente?.id} size="md">
            <option value={contatoCliente?.id}>{contatoCliente?.nome}</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Email do Contato do Cliente
          </FormLabel>

          <Input
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder=" Email do Contato do Cliente"
            fontWeight="bold"
            size="md"
            disabled={false}
            value={accountSelected?.Orcamento.contatoClienteEmail}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Telefone do Contato do Cliente
          </FormLabel>

          <Input
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder=" Telefone de Contato do Cliente"
            fontWeight="bold"
            size="md"
            onChange={(e) => {}}
            value={accountSelected?.Orcamento.contatoClienteTelefone}
          />
        </FormControl>
      </SimpleGrid>

      <Text
            mt={8}
            fontSize={18}
            color={"#422AFB"}
            fontWeight={"bold"}
            mb={4}
          >
            Status
      </Text>
      <SimpleGrid columns={6} spacing={2} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            <Badge backgroundColor={"green"} color={"white"}>
              Pre-Produção
            </Badge>
          </FormLabel>
          <SingleDatepicker
            name="date-input-validade"
            configs={{
              dateFormat: "dd/MM/yyyy",
              dayNames: "DSTQQSS".split(""), // length of 7
              monthNames:
                "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                  " "
                ), // length of 12
              firstDayOfWeek: 0,
              // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
            }}
            propsConfigs={{
              dayOfMonthBtnProps: {
                selectedBtnProps: {
                  background: "#422afb",
                  color: "white",
                },
              },
            }}
            date={new Date()}
            onDateChange={(date: any) => {
              //
            }}
          />
        </FormControl>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
           <Badge backgroundColor={"green"} color={"white"}>
             PPM Agência
            </Badge>
          </FormLabel>
          <SingleDatepicker
            name="date-input-validade"
            configs={{
              dateFormat: "dd/MM/yyyy",
              dayNames: "DSTQQSS".split(""), // length of 7
              monthNames:
                "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                  " "
                ), // length of 12
              firstDayOfWeek: 0,
              // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
            }}
            propsConfigs={{
              dayOfMonthBtnProps: {
                selectedBtnProps: {
                  background: "#422afb",
                  color: "white",
                },
              },
            }}
            date={new Date()}
            onDateChange={(date: any) => {
              //
            }}
          />
        </FormControl>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            <Badge backgroundColor={"yellow"} color={"black"}>
              PPM Cliente
            </Badge>
          </FormLabel>
          <SingleDatepicker
            name="date-input-validade"
            configs={{
              dateFormat: "dd/MM/yyyy",
              dayNames: "DSTQQSS".split(""), // length of 7
              monthNames:
                "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                  " "
                ), // length of 12
              firstDayOfWeek: 0,
              // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
            }}
            propsConfigs={{
              dayOfMonthBtnProps: {
                selectedBtnProps: {
                  background: "#422afb",
                  color: "white",
                },
              },
            }}
            date={new Date()}
            onDateChange={(date: any) => {
              //
            }}
          />
        </FormControl>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            <Badge backgroundColor={"red"} color={"white"}>
               Filmagem
            </Badge>
          </FormLabel>
          <SingleDatepicker
            name="date-input-validade"
            configs={{
              dateFormat: "dd/MM/yyyy",
              dayNames: "DSTQQSS".split(""), // length of 7
              monthNames:
                "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                  " "
                ), // length of 12
              firstDayOfWeek: 0,
              // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
            }}
            propsConfigs={{
              dayOfMonthBtnProps: {
                selectedBtnProps: {
                  background: "#422afb",
                  color: "white",
                },
              },
            }}
            date={new Date()}
            onDateChange={(date: any) => {
              //
            }}
          />
        </FormControl>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
             <Badge backgroundColor={"red"} color={"white"}>
               Finalização
            </Badge>
          </FormLabel>
          <SingleDatepicker
            name="date-input-validade"
            configs={{
              dateFormat: "dd/MM/yyyy",
              dayNames: "DSTQQSS".split(""), // length of 7
              monthNames:
                "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                  " "
                ), // length of 12
              firstDayOfWeek: 0,
              // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
            }}
            propsConfigs={{
              dayOfMonthBtnProps: {
                selectedBtnProps: {
                  background: "#422afb",
                  color: "white",
                },
              },
            }}
            date={new Date()}
            onDateChange={(date: any) => {
              //
            }}
          />
        </FormControl>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            <Badge backgroundColor={"red"} color={"white"} >
               Aprovação
            </Badge>
          </FormLabel>
          <SingleDatepicker
            name="date-input-validade"
            configs={{
              dateFormat: "dd/MM/yyyy",
              dayNames: "DSTQQSS".split(""), // length of 7
              monthNames:
                "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                  " "
                ), // length of 12
              firstDayOfWeek: 0,
              // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
            }}
            propsConfigs={{
              dayOfMonthBtnProps: {
                selectedBtnProps: {
                  background: "#422afb",
                  color: "white",
                },
              },
            }}
            date={new Date()}
            onDateChange={(date: any) => {
              //
            }}
          />
        </FormControl>
      </SimpleGrid>
    </Box>
  );
};
export default ProjectHeader;
